<template>
    <div id="map-container">
        <div id="map"></div>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
    name: "MapComponent",
    props: {
        posts: Array
    },
    setup(props) {
        const map = ref(null);
        onMounted(() => {
            mapboxgl.accessToken = "pk.eyJ1IjoiamFndWFydCIsImEiOiJjbTBlNzczdTkwbHBpMmtxdmpxOHd1bGVrIn0.HXx87UQbLt0jAAXg0u9jYg";
            const map = new mapboxgl.Map({
                container: "map",
                style: "mapbox://styles/mapbox/streets-v12",
                center: [2.0, 46.0], // Coordonnées centrales
                zoom: 4, // Niveau de zoom
            });
            // Étape 1 : Compter les occurrences de chaque pays
            const countryCounts = {};
            props.posts.forEach(post => {
                const key = post.country;
                if (countryCounts[key]) {
                    countryCounts[key].count++;
                } else {
                    countryCounts[key] = { count: 1, latitude: parseFloat(post.latitude), longitude: parseFloat(post.longitude) };
                }
            });
            Object.entries(countryCounts).forEach(([, data]) => {
                const { latitude, longitude } = data;
                const lat = parseFloat(latitude);
                const lon = parseFloat(longitude);
                new mapboxgl.Marker({ color: 'black', rotation: 45 })
                    .setLngLat([lon, lat])
                    .addTo(map);
                
            })
            map.addControl(new mapboxgl.FullscreenControl());


        });

        return { map };
    }
};
</script>

<style scoped>
#map-container {
    width: 100%;
    height: 500px;
}

#map {
    width: 100%;
    height: 100%;
}
</style>